module.exports = __webpack_public_path__ + "static/media/lexy.751956e4.png";